import UsersGuide from '../components/onboarding/UsersGuide';
import { Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const Users = () => {
  return (
    <>
      <Helmet>
        <title>Team Members | MindShare Calendar</title>
      </Helmet>
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          Team Members
        </Typography>
        
        <UsersGuide />
        
        {/* Rest of the existing content */}
      </Container>
    </>
  );
};

export default Users; 